import axios from "axios";
import { useState } from "react";
import { toast } from "react-toastify";
const { REACT_APP_API_KEY } = process.env;

const useAddDoctor = ({ doctorInfo = {}, isEditable = false, currentItem = {} }) => {
  const [isAddDoctorLoading, setIsAddDoctorLoading] = useState(false);

  const validateDoctorInfo = (info) => {
    if (!info.doctorName) return "Doctor name is required";
    if (!info.mobileNumber) return "Mobile number is required";
    if (!info.username) return "Username is required";
    if (!isEditable && !info.password) return "Password is required";
    if (!isEditable && info.password !== info.confirmPassword) return "Passwords do not match";
    // Make the following optional
    // if (!info.email) return "Email is required";
    // if (!info.registrationNo) return "Registration number is required";
    // if (!info.signature) return "Signature is required";
    // if (!info.stamp) return "Stamp is required";
    // if (!info.clinicId) return "Clinic ID is required";
    return null;
  };

  const onAddNewDoctor = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const validationError = validateDoctorInfo(doctorInfo);
    if (validationError) {
      toast.error(validationError);
      return;
    }

    setIsAddDoctorLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      // Get the clinic admin's ID from session storage
      const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
      const headId = userDetails?.id;

      if (!headId) {
        toast.error("Unable to get clinic admin details");
        return;
      }

      const requestData = {
        username: doctorInfo.username,
        userType: "DOCTOR",
        name: doctorInfo.doctorName,
        email: doctorInfo.email,
        mobileNumber: doctorInfo.mobileNumber,
        registrationNo: doctorInfo.registrationNo,
        signature: doctorInfo.signature,
        stamp: doctorInfo.stamp,
        photo: doctorInfo.photo,
        age: doctorInfo.age,
        headId: headId,
      };

      // Only include password in request if it's provided (for new doctors or password updates)
      if (doctorInfo.password) {
        requestData.password = doctorInfo.password;
      }

      const response = await axios({
        method: isEditable ? 'patch' : 'post',
        url: `/api/v1/users${isEditable ? `/${currentItem.id}` : ''}`,
        data: requestData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data) {
        toast.success(isEditable ? "Doctor updated successfully" : "Doctor added successfully");
        return response.data;
      }
    } catch (error) {
      console.error("Error with doctor:", error.response?.data?.message);
      const errorMessage = error.response?.data?.message[0] || `Error ${isEditable ? 'updating' : 'adding'} doctor`;
      toast.error(errorMessage);
      throw error;
    } finally {
      setIsAddDoctorLoading(false);
    }
  };

  const onAddTimeSlot = async (e) => {
    e.preventDefault();
    setIsAddDoctorLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      await axios.post(
        `${REACT_APP_API_KEY}/api/v1/mmu/doctor/slots/ansh123/${doctorInfo.selectedDate}`,
        {
          // slots: [{ time: "08:45 AM", isAvailable: true }],
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "ngrok-skip-browser-warning": "hgs",
          },
        }
      );
      toast.success("Time slot added successfully");
    } catch (error) {
      console.error(error);
      toast.error("Error adding doctor");
    } finally {
      setIsAddDoctorLoading(false);
    }
  };

  return {
    isAddDoctorLoading,
    onAddNewDoctor,
    onAddTimeSlot,
  };
};

export default useAddDoctor;
